export default __webpack_public_path__ + "static/media/icon-box.c70b5e4e.svg";